import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import LoginLayout from "../../component/appLayouts/login";
import PasswordInput from "../../component/passwordInput";
import { toast } from "react-toastify";
import axios from "axios";
import SubmitBtn from "../../component/submitButton";
import { useTranslation } from "react-i18next";

export default function SignUp() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "", // Added phone field
    role: "visitor", // Default role as visitor
    company: "", // Champ ajouté pour la compagnie
    KBIS: "", // Champ ajouté pour KBIS
    activitySector: "", // Champ ajouté pour le secteur d'activité
    SIRET: "", // Champ ajouté pour le SIRET
    SIREN: "", // Champ ajouté pour le SIREN
  });
  const { t } = useTranslation();

  const [formErrors, setFormErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.firstName) errors.firstName = "Le prénom est requis";
    if (!formData.lastName) errors.lastName = "Le nom est requis";
    if (!formData.email) errors.email = "L'email est requis";
    if (!formData.phone) errors.phone = "Le numéro de téléphone est requis"; // Phone validation
    if (!formData.company) errors.company = "Le nom de la compagnie est requis"; // Company validation
    if (!formData.activitySector)
      errors.activitySector = "Le secteur d'activité est requis"; // Activity sector validation
    if (!formData.KBIS) errors.KBIS = "Le KBIS est requis"; // KBIS validation

    if (!formData.SIRET) errors.SIRET = "Le SIRET est requis"; // SIRET validation
    if (!/^\d+$/.test(formData.phone))
      if (!formData.password) errors.password = "Le mot de passe est requis";
    if (formData.password !== formData.confirmPassword)
      errors.confirmPassword = "Les mots de passe ne correspondent pas";

    return errors;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const errors = validateForm();
  //   if (Object.keys(errors).length > 0) {
  //     setFormErrors(errors);
  //     return;
  //   }

  //   setIsLoading(true);

  //  const payload = {
  //    firstname: formData.firstName,
  //    lastname: formData.lastName,
  //    email: formData.email,
  //    password: formData.password,
  //    confirmPassword: formData.confirmPassword,
  //    phone: formData.phone,
  //    Role: formData.role, // Ensure this is 'Role', not 'role'
  //  };
  //   if (selectedFile) {
  //     payload.file = selectedFile; // Add file if selected
  //   }

  //   try {
  // const response = await axios.post("/users/register-visitor", payload, {
  //   headers: {
  //     "Content-Type": "application/json", // Correct Content-Type
  //   },
  // });
  //     toast.success("Inscription réussie !");
  //       const userId = response.data?.id;

  //     // Rediriger vers le formulaire de création de devis
  //     navigate("/create-devis", { state: { userId } });
  //   } catch (err) {
  //     const msg = err.response?.data?.message || "Erreur d'inscription";
  //     toast.error(msg);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const formState = {
      firstname: formData.firstName,
      lastname: formData.lastName,
      email: formData.email,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      phone: formData.phone,
      role: formData.role,
      file: selectedFile,
      company: formData.company,
      activitySector: formData.activitySector,
      KBIS: formData.KBIS,
      SIRET: formData.SIRET,
      SIREN: formData.SIREN,
    };

    navigate("/create-devis", { state: { user: formState } }); // 👉 pas d'appel à l'API ici
  };

  return (
    <div id="login-page" className="login-page " style={{ minHeight: "180vh" }}>
      <LoginLayout title="Inscrivez-vous Maintenant">
        <form onSubmit={handleSubmit}>
          <div className="row mailing-section p-3">
            <div className="mb-3 mt-4 secteur-title">{t("Nom")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="lastName"
              placeholder="Entrez votre nom"
              value={formData.lastName}
              onChange={handleChange}
            />
            {formErrors.lastName && (
              <small className="text-danger">{formErrors.lastName}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("Prénom")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="firstName"
              placeholder="Entrez votre prénom"
              value={formData.firstName}
              onChange={handleChange}
            />
            {formErrors.firstName && (
              <small className="text-danger">{formErrors.firstName}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("Email")}</div>
            <input
              type="email"
              className="form__input input-login"
              name="email"
              placeholder="Entrez votre adresse email"
              value={formData.email}
              onChange={handleChange}
            />
            {formErrors.email && (
              <small className="text-danger">{formErrors.email}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("Téléphone")}</div>
            <input
              type="number"
              className="form__input input-login"
              name="phone"
              placeholder="Entrez votre numéro de téléphone"
              value={formData.phone}
              onChange={handleChange}
            />
            {formErrors.phone && (
              <small className="text-danger">{formErrors.phone}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("Entréprise")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="company"
              placeholder="Nom de la compagnie"
              value={formData.company}
              onChange={handleChange}
            />
            {formErrors.company && (
              <small className="text-danger">{formErrors.company}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">
              {t("Secteur d'activité")}
            </div>
            <input
              type="text"
              className="form__input input-login"
              name="activitySector"
              placeholder="Secteur d'activité"
              value={formData.activitySector}
              onChange={handleChange}
            />
            {formErrors.activitySector && (
              <small className="text-danger">{formErrors.activitySector}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("SIRET")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="SIRET"
              placeholder="SIRET"
              value={formData.SIRET}
              onChange={handleChange}
            />{" "}
            {formErrors.SIRET && (
              <small className="text-danger">{formErrors.SIRET}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">{t("SIREN")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="SIREN"
              placeholder="SIREN"
              value={formData.SIREN}
              onChange={handleChange}
            />
            <div className="mb-3 mt-4 secteur-title">{t("KBIS")}</div>
            <input
              type="text"
              className="form__input input-login"
              name="KBIS"
              placeholder="KBIS"
              value={formData.KBIS}
              onChange={handleChange}
            />
            <div className="mb-3 mt-4 secteur-title">{t("Mot de passe")}</div>
            <PasswordInput
              name="password"
              className="form__input input-login"
              placeholder="Mot de passe"
              value={formData.password}
              onChange={handleChange}
            />
            {formErrors.password && (
              <small className="text-danger">{formErrors.password}</small>
            )}
            <div className="mb-3 mt-4 secteur-title">
              {t("Confirmer mot de passe")}
            </div>
            <PasswordInput
              type="password"
              name="confirmPassword"
              className="form__input input-login"
              placeholder="Confirmer mot de passe"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            {formErrors.confirmPassword && (
              <small className="text-danger">
                {formErrors.confirmPassword}
              </small>
            )}
            {/* <input
            type="file"
            className="form-control my-2"
            onChange={handleFileChange}
          /> */}
            <div className="form-check my-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="terms"
                required
              />
              <label className="form-check-label" htmlFor="terms">
                J’accepte les termes et conditions
              </label>
            </div>
            {formErrors.role && (
              <small className="text-danger">{formErrors.role}</small>
            )}
          </div>
          <SubmitBtn value={"Suivant"} disabled={isLoading} />

          {/* <button type="submit" className="btn-submit" disabled={isLoading}>
            {isLoading ? "Chargement..." : "Suivant"}
          </button> */}
        </form>
      </LoginLayout>
    </div>
  );
}
